module.exports = __webpack_public_path__ + "static/media/al.4eb491e7.svg";